import { Authorize } from "planning-portal-library/src/lib/core/domain";
import { Tenant } from "planning-portal-library/src/lib/core/domain/models/tenant";

export class GetTenantId {
  static readonly type = "[PlanningPortalGlobal] Get Tenant Id";

  constructor() {
  }
}

export class GetClientId {
  static readonly type = "[PlanningPortalGlobal] Get Client Id";

  constructor() {
  }
}

export class GetOrganizationUnitId {
  static readonly type = "[PlanningPortalGlobal] Get OrganizationUnit Id";

  constructor() {
  }
}

export class SetConnectionId {
  static readonly type = "[PlanningPortalGlobal] Set Connection Id";

  constructor(public payload: string | undefined) {
  }
}


export class SelectedDistributionLane {
  static readonly type = "[Layout] Set Distribution Lane";

  constructor(public payload: string[] | undefined) {
  }
}

export class SetDistributionLaneId {
  static readonly type = "[PlanningPortalGlobal] Set Distribution Lane Id";

  constructor(public payload: string | undefined) {
  }
}

export class Login {
  static readonly type = '[PlanningPortalGlobal] login user';
  constructor(public payload: Authorize | undefined) {}
}
export class SetTenant {
  static readonly type = "[PlanningPortalGlobal] Set Tenant";

  constructor(public payload: Tenant | undefined) {
  }
}
export class SetTenantId {
  static readonly type = "[PlanningPortalGlobal] Set Tenant Id";

  constructor(public payload: string | undefined) {
  }
}
export class ValidateJobTerminals {
  static readonly type = "[PlanningPortalGlobal] Validate Job Terminals";

  constructor(public payload: boolean | undefined) {
  }
}

